import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { ToggleSwitch } from '../../widgets';
import moment from 'moment';
import { Row, Col } from 'react-bootstrap';
import { refreshDashboard } from '../../../actions/dashboard';
import { getUserConfiguration, updateConfiguration, userConfiguration } from '../../../actions/user';

const Refresh = () => {
    const dispatch =  useDispatch()
    const timezoneIdentifier = useSelector((state) => state.farm.currentFarm.timezone_identifier);
    const refreshCount = useSelector((state) => state.dashboard.refreshCount);
    const autoRefresh = useSelector(
      (state) =>
        state.user.configuration.autoRefresh &&
        state.user.configuration.autoRefresh.hasOwnProperty("dashboard")
          ? state.user.configuration.autoRefresh.dashboard
          : true
    );
  
    const [time, setTime] = useState(0);
    let timerId = null;
    let lastRefreshTime = moment.utc().tz(timezoneIdentifier);

    useEffect(() => {
        dispatch(getUserConfiguration("autoRefresh", { configuration_name: "AutoRefresh" }));
    }, []);

    useEffect(() => {
        clearTimer();
        if (autoRefresh) setTimer();
        return clearTimer;
    }, [refreshCount, autoRefresh]);

    const handleRefreshTimer = () => {
        const now = moment.utc().tz(timezoneIdentifier);
        setTime(now.diff(lastRefreshTime, "seconds"));
    };

    const setTimer = () => {
        timerId = setInterval(handleRefreshTimer, 20 * 1000);
    }

    const clearTimer = () => {
        setTime(0);
        if (timerId) clearInterval(timerId);
        timerId = null;
    };

    const handleRefreshToggle = (e) => {
        const isChecked = e.target.checked;
        const cb = (isSaved) => !isSaved && dispatch(userConfiguration("autoRefresh", { dashboard: !isChecked }));

        dispatch(userConfiguration("autoRefresh", { dashboard: isChecked }));
        dispatch(updateConfiguration({
            configuration_name: "AutoRefresh",
            configuration: { dashboard: isChecked }
        }, cb))

        if (isChecked) dispatch(refreshDashboard());
    }

    return <Col >
        <Row className="refresh-time-info">
            <span className="label">Auto Refresh</span>
            <ToggleSwitch
                onChange={handleRefreshToggle}
                checked={autoRefresh}
                title={autoRefresh ? "Disable auto refresh" : "Enable auto refresh"}
            />
            <span className="refresh-info">
                {autoRefresh ? <><i className="fa fa-clock-o" aria-hidden="true" />
                    <span>{time < 20 ? "Just now" : `${time} seconds ago`}</span></>
                    : <div>
                        <i
                            title="Refresh"
                            className="fa fa-refresh btn-refresh"
                            aria-hidden="true"
                            onClick={() => dispatch(refreshDashboard())}
                        />
                    </div>}
            </span>
        </Row>
    </Col>
}

export default Refresh;
